import { createFileRoute } from "@tanstack/react-router"
import { OrganizationDetailPage } from "@/pages/organization-detail"

export const Route = createFileRoute("/organizations_/$organizationId")({
	staticData: {
		breadcrumbKey: "organizations.detail.breadcrumbFallback",
	},
	component: function OrganizationDetailRoute() {
		const { organizationId } = Route.useParams()
		return <OrganizationDetailPage organizationId={organizationId} />
	},
})
